<template>
  <div class="animated fadeIn" v-permission="'VIEW_PORTFOLIO'">
    <portfolio-widget-row :fetch="true" />
    <div id="vulnerabilitiesToolbar" class="bs-table-custom-toolbar">
      <b-button
        size="md"
        variant="outline-primary"
        v-b-modal.vulnerabilityCreateVulnerabilityModal
        v-permission="PERMISSIONS.VULNERABILITY_MANAGEMENT"
      >
        <span class="fa fa-plus"></span>
        {{ $t('message.create_vulnerability') }}
      </b-button>
    </div>
    <bootstrap-table
      ref="table"
      :columns="columns"
      :data="data"
      :options="options"
      @on-load-success="onLoadSuccess"
    >
    </bootstrap-table>
    <vulnerability-create-vulnerability-modal
      v-on:refreshTable="refreshTable"
    />
  </div>
</template>

<script>
import { loadUserPreferencesForBootstrapTable } from '@/shared/utils';
import $ from 'jquery';
import xssFilters from 'xss-filters';
import permissionsMixin from '../../../mixins/permissionsMixin';
import routerMixin from '../../../mixins/routerMixin';
import common from '../../../shared/common';
import PortfolioWidgetRow from '../../dashboard/PortfolioWidgetRow';
import VulnerabilityCreateVulnerabilityModal from './VulnerabilityCreateVulnerabilityModal';

export default {
  mixins: [permissionsMixin, routerMixin],
  components: {
    VulnerabilityCreateVulnerabilityModal,
    PortfolioWidgetRow,
  },
  methods: {
    apiUrl: function () {
      return `${this.$api.BASE_URL}/${this.$api.URL_VULNERABILITY}`;
    },
    refreshTable: function () {
      this.$refs.table.refresh({
        url: this.apiUrl(),
        pageNumber: 1,
        silent: true,
      });
    },
    initializeTooltips: function () {
      $('[data-toggle="tooltip"]').tooltip();
    },
    onLoadSuccess: function () {
      loadUserPreferencesForBootstrapTable(
        this,
        'VulnerabilityList',
        this.$refs.table.columns,
      );
    },
  },
  data() {
    return {
      showInactiveProjects: this.showInactiveProjects,
      columns: [
        {
          title: this.$t('message.name'),
          field: 'vulnId',
          sortable: true,
          formatter(value, row, index) {
            let url = xssFilters.uriInUnQuotedAttr(
              '../vulnerabilities/' +
                row.source +
                '/' +
                encodeURIComponent(value),
            );
            return (
              common.formatSourceLabel(row.source) +
              ` <a href="${url}">${xssFilters.inHTMLData(value)}</a>`
            );
          },
        },
        {
          title: this.$t('message.aliases'),
          field: 'aliases',
          visible: false,
          formatter(value, row, index) {
            if (typeof value !== 'undefined') {
              let label = '';
              const aliases = common.resolveVulnAliases(row.source, value);
              for (let i = 0; i < aliases.length; i++) {
                let alias = aliases[i];
                let url = xssFilters.uriInUnQuotedAttr(
                  '../vulnerabilities/' +
                    alias.source +
                    '/' +
                    encodeURIComponent(alias.vulnId),
                );
                label +=
                  common.formatSourceLabel(alias.source) +
                  ` <a href="${url}">${xssFilters.inHTMLData(
                    alias.vulnId,
                  )}</a>`;
                if (i < aliases.length - 1) label += '<br/><br/>';
              }
              return label;
            }
          },
        },
        {
          title: this.$t('message.published'),
          field: 'published',
          sortable: true,
          formatter(value, row, index) {
            if (typeof value !== 'undefined') {
              return common.formatTimestamp(value);
            }
          },
        },
        {
          title: this.$t('message.cwe'),
          field: 'cwes',
          sortable: false,
          formatter(value, row, index) {
            if (typeof value !== 'undefined') {
              let s = '';
              for (let i = 0; i < value.length; i++) {
                let cwe = value[i];
                if (i > 0) {
                  s += ',&nbsp;&nbsp;&nbsp;';
                }
                s += `CWE-${cwe.cweId}`;
              }
              return s;
            }
          },
        },
        {
          title: this.$t('message.projects'),
          field: 'affectedActiveProjectCount',
          class: 'tight',
          sortable: false,
        },
        {
          title: this.$t('message.severity'),
          field: 'severity',
          sortable: false,
          formatter(value, row, index) {
            if (typeof value !== 'undefined') {
              return common.formatSeverityLabel(value);
            }
          },
        },
      ],
      data: [],
      options: {
        onPostBody: this.initializeTooltips,
        search: true,
        showColumns: true,
        showRefresh: true,
        pagination: true,
        silentSort: false,
        sidePagination: 'server',
        queryParamsType: 'pageSize',
        pageList: '[10, 25, 50, 100]',
        pageSize:
          localStorage &&
          localStorage.getItem('VulnerabilityListPageSize') !== null
            ? Number(localStorage.getItem('VulnerabilityListPageSize'))
            : 10,
        sortName:
          localStorage &&
          localStorage.getItem('VulnerabilityListSortName') !== null
            ? localStorage.getItem('VulnerabilityListSortName')
            : undefined,
        sortOrder:
          localStorage &&
          localStorage.getItem('VulnerabilityListSortOrder') !== null
            ? localStorage.getItem('VulnerabilityListSortOrder')
            : undefined,
        searchText: this.$route.query.searchText
          ? this.$route.query.searchText
          : '',
        icons: {
          refresh: 'fa-refresh',
        },
        toolbar: '#vulnerabilitiesToolbar',
        responseHandler: function (res, xhr) {
          res.total = xhr.getResponseHeader('X-Total-Count');
          return res;
        },
        url: this.apiUrl(),
        onPageChange: (number, size) => {
          if (localStorage) {
            localStorage.setItem('VulnerabilityListPageSize', size.toString());
          }
        },
        onColumnSwitch: (field, checked) => {
          if (localStorage) {
            localStorage.setItem(
              'VulnerabilityListShow' + common.capitalize(field),
              checked.toString(),
            );
          }
        },
        onSort: (name, order) => {
          if (localStorage) {
            localStorage.setItem('VulnerabilityListSortName', name);
            localStorage.setItem('VulnerabilityListSortOrder', order);
          }
        },
        onSearch: (text) => {
          this.setSearchTextQuery(text);
        },
      },
    };
  },
};
</script>
